import React, { useState } from 'react';
import styles from './FaqPage.module.css';

const faqSections = [
  {
    title: <><img src="/icons/ticket.svg" alt="チケット" style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />チケット購入について</>,
    items: [
      {
        q: 'チケットはどうやって購入できますか？',
        a: 'ログイン後にイベントページからチケット種別と枚数を選択し、決済を行うことで購入できます。',
      },
      {
        q: '支払い方法は何がありますか？',
        a: 'クレジットカード決済（Stripe）に対応しています。',
      },
      {
        q: '購入後のキャンセルはできますか？',
        a: '原則としてキャンセル・返金はできません。\nただし、イベントが中止された場合に限り返金されます。',
      },
      {
        q: '購入完了メールが届きません',
        a: '迷惑メールフォルダをご確認ください。\nそれでも見つからない場合は、マイページの「購入済みイベント」からご確認いただけます。',
      },
      {
        q: 'チケットはどこで確認できますか？',
        a: 'マイページの「購入済みイベント」から確認できます。',
      },
    ],
  },
  {
    title: '📱 電子チケット・入場について',
    items: [
      {
        q: '紙チケットはありますか？',
        a: 'ありません。すべて電子チケットとなります。',
      },
      {
        q: '入場方法は？',
        a: 'マイページのチケット画面を受付に提示し、スタッフがチェックイン処理を行います。',
      },
      {
        q: 'チェックインとは何ですか？',
        a: '入場時にチケットの使用済み処理を行う機能です。一度チェックインすると再利用できません。',
      },
      {
        q: '間違えてチェックインされた場合は？',
        a: '会場スタッフまたは主催者にご相談ください。',
      },
    ],
  },
  {
    title: '💳 決済・返金について',
    items: [
      {
        q: '手数料はかかりますか？',
        a: 'イベントにより異なります。購入画面で総額をご確認ください。',
      },
      {
        q: '返金はどのように行われますか？',
        a: 'イベント中止時のみ、決済方法に応じて返金されます。',
      },
      {
        q: 'チャージバックとは何ですか？',
        a: 'クレジットカード会社に対して支払いを取り消す手続きです。不正利用と判断された場合、アカウント制限の対象となる場合があります。',
      },
    ],
  },
  {
    title: '🎤 イベント・主催者について',
    items: [
      {
        q: 'イベントに関する問い合わせはどこにすればいいですか？',
        a: 'イベントの内容・開催に関する問い合わせは主催者へお願いします。',
      },
      {
        q: 'イベントが中止になった場合は？',
        a: '主催者の判断により中止された場合、自動的に返金処理が行われます。',
      },
    ],
  },
  {
    title: '🧑‍💼 販売者（主催者）向け',
    items: [
      {
        q: '誰でもチケット販売できますか？',
        a: 'アカウント登録後、必要情報を入力し、審査・承認後に販売可能となります。',
      },
      {
        q: '手数料は誰が負担しますか？',
        a: '原則として販売者が負担しますが、設定により購入者に転嫁することも可能です。',
      },
      {
        q: '売上はいつ振り込まれますか？',
        a: 'イベント終了後、7日後に振込処理が行われます。',
      },
      {
        q: 'チャージバックが発生した場合は？',
        a: 'チャージバックに関する損失（手数料含む）は販売者負担となります。',
      },
      {
        q: 'イベントを中止した場合は？',
        a: '購入者への返金が行われ、関連手数料は販売者負担となります。',
      },
    ],
  },
  {
    title: <><img src="/icons/image.svg" alt="ギャラリー" style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />ギャラリー（写真投稿）について</>,
    items: [
      {
        q: '写真は誰でも投稿できますか？',
        a: 'イベント参加者、主催者、出演者などに投稿権限があります。',
      },
      {
        q: '投稿した写真は誰が管理しますか？',
        a: '主催者が表示・非表示・削除の管理を行う場合があります。',
      },
      {
        q: '他人が写っている写真を投稿していいですか？',
        a: '必要な許可を得た上で投稿してください。無断投稿は禁止されています。',
      },
      {
        q: '不適切な写真を見つけた場合は？',
        a: 'お問い合わせよりご連絡ください。',
      },
    ],
  },
  {
    title: <><img src="/icons/pin.svg" alt="会場・地図" style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />会場・地図について</>,
    items: [
      {
        q: '会場の場所はどこで確認できますか？',
        a: 'イベントページの地図から確認できます。',
      },
      {
        q: '地図の位置が違う場合があります',
        a: '主催者が登録した情報に基づいて表示されるため、実際と異なる場合があります。',
      },
    ],
  },
  {
    title: <><img src="/icons/key.svg" alt="アカウント・セキュリティ" style={{width: '1.2em', verticalAlign: 'middle', marginRight: '0.3em'}} />アカウント・セキュリティ</>,
    items: [
      {
        q: 'ログインできません',
        a: 'パスワードリセットをご利用ください。',
      },
      {
        q: 'アカウントを削除したい',
        a: 'お問い合わせよりご連絡ください。',
      },
    ],
  },
  {
    title: '📩 その他',
    items: [
      {
        q: 'お問い合わせはどこからできますか？',
        a: 'お問い合わせフォームよりご連絡ください。',
      },
    ],
  },
];

const FaqPage = () => {
  const [openKey, setOpenKey] = useState('0-0');

  const toggle = (key) => {
    setOpenKey((prev) => (prev === key ? '' : key));
  };

  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <h1 className={styles.title}>IRIE TIX よくある質問（FAQ）</h1>
        <p className={styles.subtitle}>
          ご不明点は、まずこちらのFAQをご確認ください。
          解決しない場合は <a className={styles.mailLink} href="/contact">お問い合わせページ</a> からご連絡ください。
        </p>
      </div>

      {faqSections.map((section, sectionIndex) => (
        <section key={section.title} className={styles.section}>
          <h2 className={styles.sectionTitle}>{section.title}</h2>
          {section.items.map((item, itemIndex) => {
            const itemKey = `${sectionIndex}-${itemIndex}`;
            const isOpen = openKey === itemKey;

            return (
              <div key={item.q} className={styles.qaItem}>
                <button
                  type="button"
                  className={styles.qButton}
                  onClick={() => toggle(itemKey)}
                  aria-expanded={isOpen}
                >
                  <span className={styles.q}>Q. {item.q}</span>
                  <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>▾</span>
                </button>

                {isOpen && <p className={styles.a}>A. {item.a}</p>}
              </div>
            );
          })}
        </section>
      ))}
    </div>
  );
};

export default FaqPage;
